import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash/fp';
import { routes } from 'constants/config';
import filterSuggestions from 'utils/filterSuggestions';
import * as selectors from 'selectors/pathBuilder';
import { toggleEditingUIElementByName } from 'actions/pathBuilder';
import * as actions from 'actions/pathBuilder/libraryContents';
import { Icon } from 'ui';
import InfoTooltip from 'components/shared/InfoTooltip';
import ContentLearningLibrary from 'components/shared/ContentLearningLibrary';
import { hasFeatureFlags } from 'utils/features';
import Section, { SectionHeader } from './Section';

class LearningLibrary extends PureComponent {
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.shouldReloadLibraryContents(nextProps)) {
      this.props.reloadLibraryContents();
    }
  }

  shouldReloadLibraryContents(nextProps) {
    const { hasRelatedUrls } = this.props;
    const { hasRelatedUrls: willHaveRelatedUrls } = nextProps;
    return willHaveRelatedUrls && willHaveRelatedUrls !== hasRelatedUrls;
  }

  shouldShowEditButton() {
    const { libraryContents } = this.props;
    if (!isEmpty(libraryContents)) return true;
    return false;
  }

  render() {
    const hasUnificationFeatureFlag = hasFeatureFlags([
      'readiness-enable-unification',
    ]);
    const learnToolTiptext = hasUnificationFeatureFlag
      ? t('learn.more_info.advanced.unified_path')
      : t('learn.more_info.advanced.path');
    const { features, editing, isArchived, isCertification, ...props } =
      this.props;
    return (
      <Section>
        <SectionHeader className="d-f jc-sb">
          <span>
            <span className="mr-4">
              {hasUnificationFeatureFlag
                ? t('learn.unified_title')
                : t('learn.title')}
            </span>
            <InfoTooltip
              tooltip={
                isCertification
                  ? t(
                      'certifications.certification_builder.sidebar.learn_tooltip',
                    )
                  : learnToolTiptext
              }
            />
          </span>
          {!isArchived && !editing && this.shouldShowEditButton() && (
            <button
              type="button"
              className="u-linkBtn fz-base fw-n"
              onClick={props.toggleEditing}
            >
              <Icon name="edit" className="mr-4" />
              Edit
            </button>
          )}
        </SectionHeader>
        <ContentLearningLibrary
          editing={editing}
          onCreateContent={props.createLibraryContent}
          onRemoveContent={props.removeLibraryContent}
          toggleEditing={props.toggleEditing}
          libraryContents={props.libraryContents}
          setLibraryVisibility={props.setLibraryVisibility}
          availableToEveryone={props.availableToEveryone}
          emptyStateActionText={
            hasUnificationFeatureFlag ? t('learn.unified_add') : t('learn.add')
          }
          removeTooltip={t('learn.remove_from_group_learn')}
          suggestionsProps={{
            url: routes.GROUPS,
            mapResponseToSuggestions: response => response.groups,
            filterSuggestions: filterSuggestions(
              props.libraryContents,
              'group.id',
            ),
            queryParam: 'q',
          }}
        />
      </Section>
    );
  }
}

const UI_STATE_KEY = 'learningLibrary';

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  libraryContents: pathBuilder.libraryContents,
  editing: selectors.isEditingUIElementByName(pathBuilder, UI_STATE_KEY),
  isArchived: selectors.isArchived(pathBuilder),
  availableToEveryone: selectors.isAddedToLibraryForEveryone(
    pathBuilder,
    state.meta.currentCompany.everyoneGroup,
  ),
  hasRelatedUrls: selectors.hasRelatedUrls(pathBuilder),
  everyoneGroup: state.meta.currentCompany.everyoneGroup,
  isCertification: !!get('certification')(pathBuilder),
});

const mapDispatchToProps = {
  toggleEditing: toggleEditingUIElementByName.bind(null, UI_STATE_KEY),
  setLibraryVisibility: actions.setLibraryVisibilityForEveryone,
  createLibraryContent: actions.createLibraryContent,
  removeLibraryContent: actions.removeLibraryContent,
  reloadLibraryContents: actions.reloadLibraryContents,
};

export default connect(mapStateToProps, mapDispatchToProps)(LearningLibrary);
